import './style.css'
//let info = document.querySelector('#info')
//const modelViewer = document.querySelector("model-viewer");


window.showHowTo = function() {
    document.querySelector('.how-to').style.display = 'block'
}
window.closeHowTo = function() {
    document.querySelector('.how-to').style.display = 'none'
}


/*
window.scale = function() {
    const modelViewer = document.querySelector("model-viewer");  
    modelViewer.scale  = '1 1 1' // geht
    console.log('modelViewer.scale', modelViewer.scale)
}

document.querySelector(".slider").addEventListener('beforexrselect', (ev) => {
    // Keep slider interactions from affecting the XR scene.
    ev.preventDefault();
})
*/


window.iOS = function() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }



// activete aR-scale = fixed Android only

window.addEventListener("load", function() {
    let isIOS = window.iOS()
    //alert('isIOS: ' + isIOS + ' ,navigator.userAgent: ' + navigator.userAgent)

    //alert('isIOS', isIOS)
    if (!isIOS) {
        /*
        if (navigator.userAgent.match('CriOS')) {
            //alert('AR mit Chrome auf dem iPhone ist nicht gut unterstützt. Kann auf neueren iPhones funktionieren... Wir empfehlen Safari für ein besseres AR-Erlebnis.')
        }
        */
        const modelViewer = document.querySelector("model-viewer"); 
        //alert('modelViewer', modelViewer)
        modelViewer.setAttribute('ar-scale','fixed')

        //console.log('ar-scale:',    modelViewer.getAttribute('arScale'))
        //alert('ar-scale: ' + modelViewer.getAttribute('ar-scale'))
        //alert('ar-scale: ' + modelViewer.arScale)
       
    }
});

